<template>
    <div>
        <div class="cheese_footer fix_footer">
            <div class="new-btn" @click="add"><van-icon name="plus" style="line-height: 1rem;"/>新建</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheeseFooter',
        props: ['footerType','addUrl'],
        created:function()
        {
            console.log(this.footerType);
        },
        methods:{
            add()
            {
                this.$router.push(this.addUrl);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .cheese_footer
    {
        font-family: PingFangSC-Regular;
        font-size: 0.3125rem;
        color: #B2B2B2;
        text-align: center;
        line-height: 0.4375rem;
    }

    .fix_footer{
        position: absolute;
        left:50%;
        bottom: 2.5rem;
        text-align: center;
        z-index: 99;

    }

    .bottom_footer{
        margin-bottom: .5rem;
        margin-top: .5rem;
    }

    .new-btn
    {
        line-height: 1rem;
        padding: 0 1rem;
        border-radius: 1rem;
        background-color: #1989FA;
        color: #ffffff;
        font-size: .4rem;
        transform: translateX(-50%);
    }
</style>
